import { Feed, Flag, Send } from "@mui/icons-material";
import { Button, Card, CardContent, CardHeader, Grid2, IconButton, Skeleton, Typography } from "@mui/material";
import PDFBuktiPendaftaran from "../PDF/PDFBuktiPendaftaran";
import { useRef } from "react";
import DownloadPDFButtons from "../general/DownloadPDFButtons";
import LoadingSkeleton from "../general/LoadingSkeleton";
import PDFCommon from "../PDF/PDFCommon";

function DetailDownload({ dataSantriLengkap }) {
    const buktiPendaftaranRef = useRef();
    const suratInformasiRef = useRef();
    const suratKesanggupanRef = useRef();
    if (!dataSantriLengkap) {
        return (<>
            <Card>
                <CardContent>
                    <LoadingSkeleton size={1}></LoadingSkeleton>
                </CardContent>
            </Card>
        </>)
    }
    const buttonsConfig = [
        {
            label: 'Bukti Pendaftaran',
            icon: Send,
            ref: buktiPendaftaranRef,
            pdfComponent: PDFCommon,
            fileName: `bukti-pendaftaran-${dataSantriLengkap.no_daftar}.pdf`,
            data: { dataSantri: dataSantriLengkap, templateKey: 'bukti_pendaftaran' },
        },
        {
            label: 'Surat Informasi',
            icon: Feed,
            ref: suratInformasiRef,
            pdfComponent: PDFCommon,
            fileName: `surat-informasi-${dataSantriLengkap.no_daftar}.pdf`,
            data: { dataSantri: dataSantriLengkap, templateKey: 'surat_informasi' },
        },
        {
            label: 'Surat Kesanggupan',
            icon: Flag,
            ref: suratKesanggupanRef,
            pdfComponent: PDFCommon,
            fileName: `surat-kesanggupan-${dataSantriLengkap.no_daftar}.pdf`,
            data: { dataSantri: dataSantriLengkap, templateKey: 'surat_kesanggupan' },
        },
    ];
    return (
        <>
            <Card>
                <CardHeader title="Download Berkas" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    Download berkas-berkas berikut untuk diisi dan di-upload bersamaan dengan berkas yang lain.
                    <DownloadPDFButtons buttons={buttonsConfig}></DownloadPDFButtons>
                </CardContent>
            </Card>

        </>
    )
}

export default DetailDownload;